import React from 'react';

const ForSale = () => {
  return (
    <div className="sale" style={{ marginTop: '0px', marginLeft: '100px', fontSize: '12px', position: 'absolute', zIndex: 1 }}>
      <h1>Sale !!</h1>
    </div>
  );
};

export default ForSale;
